<template lang="pug">
	span
		no-ssr
			#sfc-hello-bar-wrapper(v-if="!$cookies.get('sfc-hello-bar') && !hideBar" v-show="ready" :style="`margin-top: ${marginTop}px`")
				sfc-dfp-ad(ad-unit="savingforcollege_hello_bar" sizes="[[925,131],[1065, 131]]")

				.close-x(@click="close()")
					img(:src="`${$store.state.config.s3ResourceHost}/images/icon-close.svg`" alt="Close")
</template>

<style lang="stylus" scoped>
@import '~assets/css/variables.styl'

#sfc-hello-bar-wrapper
	background-color: sfc-pale-gray-light
	position: relative
	text-align: center
	transition(margin-top, 100ms, linear)

	@media(max-width: 924px)
		display: none

	&.collapsed
		height: 0
		overflow: hidden

	.close-x
		position: absolute
		right: 30px
		top: calc(50% - 10px)
		width: 20px
		height: 20px
		line-height: body-font-line-height-xs
		margin-left: 20px
		cursor: pointer
		img
			width: 100%

		@media(max-width: 1150px)
			top: 15px
</style>

<script>
import SfcTrackingService from "@/lib/sfc-tracking-service"

export default{

	data(){
		return{
			ready: false,
			checkAdCount: 0,
			animationId: null,
			marginTop: -131,
		}
	},

	mounted(){
		this.checkAd()
	},

	computed: {
		hideBar(){
			return this.$route.path == '/student-loans' || this.$route.path == '/article/how-an-advisor-can-help-save-for-college' || this.$route.path =='/article/the-benefits-of-a-529-infographic/' || this.$route.path =='/article/the-benefits-of-a-529-infographic' || this.$route.path =='/article/how-to-get-help-saving-for-college' || this.$route.path =='/calculators/college-savings-calculator'
		}

	},

	methods:{
		close(){
			SfcTrackingService.trackAnalyticsAction("Hello Bar", "close", "")
			this.$cookies.set("sfc-hello-bar", true, {
				path: '/',
				domain: 'savingforcollege.com',
				maxAge: 365 * 24 * 60 * 60
			})
			this.ready = false
		},

		checkAd(){
			setTimeout(() => {
				try{
					if(this.ready){
						return
					}

					let wrapper = document.getElementById("sfc-hello-bar-wrapper")
					let adContainers = wrapper.getElementsByTagName("iframe")
					let adContainerContent, adContainerContentBody
					for(let adContainer of adContainers){
						adContainerContent = adContainer.contentDocument || adContainer.contentWindow.document
						adContainerContentBody = adContainerContent.body
						window.test = adContainerContentBody
						setTimeout(() => {
							if(adContainerContentBody.innerHTML){
								this.ready = true
								this.setAnimation()
								return
							}
						}, 0)
					}

					if(this.checkAdCount > 10){
						return
					}

					this.checkAdCount += 1

					setTimeout(() => {
						this.checkAd()
					},200)
				} catch {

				}

			}, 0)

		},

		setAnimation(){
			setTimeout(() => {
				this.marginTop = document.getElementById("sfc-hello-bar-wrapper").offsetHeight * -1
				// this.animationId = setInterval(this.animate, 1)
				setTimeout(() => {
					this.marginTop = 0
				},0)
			}, 0)
		},
	}
}
</script>
